import useAnalysisStore from "@/entities/analysis-ai/model/useAnalysisStore";
import useRecommendedSpreadStore from "@/entities/analysis-ai/model/useRecommendedSpreadStore";
import useSpreadStore from "@/entities/spread/model/useSpreadStore";
import type { TarotCard } from "@/entities/tarot-card/model/types";
import useCardStore from "@/entities/tarot-card/model/useCardStore";
import useDeckStore from "@/entities/tarot-deck/model/useDeckStore";
import useQuestionStore from "@/features/change-question/model/useQuestionStore";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function shuffleCards(deck: TarotCard[]) {
  //shuffle cards and reversed position
  const shuffled = [...deck]
    .sort(() => Math.random() - 0.5)
    .map((card) => ({ ...card, reversed: Math.random() < 0.5 }));
  return shuffled;
}

export function resetStates() {
  useAnalysisStore.getState().clearAnalysis();
  useAnalysisStore.getState().resetRequest();
  useRecommendedSpreadStore.getState().clearRecommendedSpread();
  useSpreadStore.getState().setSelectedSpread(null);
  useCardStore.getState().clearSelectedCards();
  useCardStore.getState().setSelectionComplete(false);
  useQuestionStore.getState().setQuestion("");
  useQuestionStore.getState().setNeedToWriteQuestion(false);

  const cards = useDeckStore.getState().selectedDeckCards;
  useCardStore.getState().setShuffledCards(shuffleCards(cards));
}
